import React, { useContext, useEffect, useState } from 'react';

import { observer } from 'mobx-react-lite';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';

import Button from 'components/common/Button/Button';
import { RootStoreContext } from 'index';
import { ApplicationRoute } from 'routes/routes.enums';

import styles from './ThankYouPage.module.scss';
import { maskEmail } from '../RegistrationProcess/registrationProcess.utils';

enum PageType {
  PartialCompletion = 'PartialCompletion',
  FullCompletion = 'FullCompletion',
}

const ThankYouPage = () => {
  const navigator = useNavigate();
  const { prequalificationStore } = useContext(RootStoreContext);
  const { mainContact, assignedTeamMember, prequalificationInformation } = prequalificationStore;
  const [pageType, setPageType] = useState<PageType>(PageType.PartialCompletion);

  const handleLogIn = () => {
    navigator(ApplicationRoute.Login);
  };
  const handleRecoverAccount = () => {
    navigator(ApplicationRoute.RequestResetPassword);
  };

  useEffect(() => {
    if (prequalificationInformation?.registrationInformationFullComplete) {
      setPageType(PageType.FullCompletion);
    }
  }, [prequalificationInformation?.registrationInformationFullComplete]);

  return (
    <div className={styles.infoContainer}>
      <div className={styles.mainHeader}>
        {pageType === PageType.FullCompletion
          ? 'Thank you for completing in the Intermediary Application!'
          : 'Thank you for filling in the Intermediary Application!'}
      </div>
      <div className={styles.mainContainer}>
        <div className={styles.infoText}>
          {pageType === PageType.FullCompletion
            ? 'We will work quickly to get you approved!'
            : 'The information you provided is appreciated, but we will need the missing required fields to be completed before we can complete processing.'}
        </div>
        <div className={styles.subHeader}>What's next?</div>
        {pageType === PageType.FullCompletion ? (
          <div className={styles.infoText}>
            An email was sent to <a className={styles.boldText}>{maskEmail(mainContact?.email!)}</a> that will allow you
            to verify the email address and log in to the Intermediary Portal. Once logged in, you will be able to check
            the status of your Intermediary Application. Other information may be requested, so it is good to log in to
            check on the status.
          </div>
        ) : (
          <div className={styles.infoText}>
            An email was sent to <a className={styles.boldText}>{maskEmail(mainContact?.email!)}</a> that will allow you
            to verify the email address and log in to the Intermediary Portal. Once logged in, you will be directed to
            complete the Intermediary Application progress.
          </div>
        )}
        <div className={styles.subHeader}>My Email is Already Verified</div>
        <div className={styles.infoText}>
          If your email is already verified and you have a password, then go to the Login page to access the portal.
        </div>
        <Button onClick={handleLogIn} className={styles.button}>
          Log In
        </Button>
        <div className={styles.subHeader}>Never Got an Email / Lost My Password</div>
        <div className={styles.infoText}>
          If you never received an email or you lost your password, go to the Recover Account page to recover your
          account.
        </div>
        <Button onClick={handleRecoverAccount} className={styles.button}>
          Recover Account
        </Button>
        <div className={styles.subHeader}>Need Assistance?</div>
        {!assignedTeamMember?.isDefault && (
          <div className={styles.infoText}>
            An HFS Account Manager has been assigned to your account. You may contact them for additional help. They
            also may reach out to you for an introduction and to offer their assistance.
          </div>
        )}
        <div className={styles.teamMemberInfoContainer}>
          <div className={clsx(styles.teamMemberInfo, styles.boldText)}>{assignedTeamMember?.name}</div>
          <div className={styles.teamMemberInfo}>{assignedTeamMember?.position}</div>
          <div className={styles.teamMemberInfo}>HFS Financial</div>
        </div>
        <div className={clsx(styles.teamMemberInfo, styles.mainColorText)}>{assignedTeamMember?.phone}</div>
        <div className={clsx(styles.teamMemberInfo, styles.orangeText)}>{assignedTeamMember?.email}</div>
        <div className={clsx(styles.teamMemberInfo, styles.orangeText)}>www.hfsfin.com</div>
      </div>
    </div>
  );
};

export default observer(ThankYouPage);
